import { Line } from "charts/templates/Line";
import data from "data/housing/months_from_movein.csv";
import { ThemeColors } from "colors";

export default function MovedIn () {

    const caption = "Source: <a href='https://www.huduser.gov/portal/datasets/assthsg.html' target='_blank'>HUD</a>";

    const tooltipOptions = function() {
        return  `In ${this.x}, the average family using public housing in ${this.series.name} stayed for ${this.y.toFixed(0)} months.`;
    }
    
    const moreOptions = {
        yAxis: {
            labels: {
              formatter: function () {
                return (this.value) + " mo.";
              }
            },
            title: {text: undefined},
          },
    }

    return (
        <Line
            data={data}
            title="Families' average duration of stay in public housing"
            caption={caption}
            columns={[
                { colName: "DE", name: "Delaware", color: ThemeColors.gray},
                { colName: "riverside", name: "Riverside", color: ThemeColors.green },
            ]}
            xAxisColumn="year"
            tooltipOptions={tooltipOptions}
            moreOptions={moreOptions}
        />
    )
}